import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getDemandOutFormatSelect } from '../api/demandOutFormatApi';

type QueryFnType = typeof getDemandOutFormatSelect;

type UseDemandOutFormatSelectOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useDemandOutFormatSelect = ({ config = {} }: UseDemandOutFormatSelectOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['demandOutFormatSelect', i18n.language],
        queryFn: () => getDemandOutFormatSelect(),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};
